export enum ORDER_SOURCE_TYPE {
  ONLINE = 1,
  OFFLINE,
  LICITACIONES
}
